import { Tooltip, Avatar } from '@material-ui/core'
import React from 'react'

export const TooltipAvatar = (props: any) => {
    return (
        <Tooltip title={props.userName}>
            <Avatar {...props}>{ props.userName && props.userName[0] }</Avatar>
        </Tooltip>
    )
}